import { TfaTypes, User, UserLoginDto } from 'modules/types/User';
import { UserCredentials } from 'modules/types/UserCredentials';
import { axiosInstance } from './axios';
import { REACT_APP_API_SERVER_URL } from './constants';

export const login = async (userCredentials: UserCredentials) => {
  const body = {
    username: userCredentials.username,
    password: userCredentials.password,
    submit: 'Login',
  };

  const response = await axiosInstance.post(
    `${REACT_APP_API_SERVER_URL}/api/login`,
    body,
  );

  const userLoginDto: UserLoginDto = response?.data;
  return userLoginDto;
};

export const tfaProviderChoice = async (provider: TfaTypes) => {
  const body = {
    provider,
  };

  const response = await axiosInstance.post(
    `${REACT_APP_API_SERVER_URL}/api/tfa-provider`,
    body,
  );

  return response;
};

export const mailCodeResend = async () => {
  const response = await axiosInstance.post(
    `${REACT_APP_API_SERVER_URL}/api/resend-mail-code`,
  );

  return response;
};

export const qrCodeReset = async (token: string) => {
  const body = {
    token,
  };

  const response = await axiosInstance.post(
    `${REACT_APP_API_SERVER_URL}/api/qr-code-reset`,
    body,
  );

  return response;
};

export const qrCodeResetRequest = async () => {
  const response = await axiosInstance.post(
    `${REACT_APP_API_SERVER_URL}/api/qr-code-reset-request`,
  );

  return response;
};

export const resetTfaProvider = async () => {
  const response = await axiosInstance.post(
    `${REACT_APP_API_SERVER_URL}/api/request-reset-provider-choice`,
  );

  return response;
};

export const resetTfaProviderApproved = async (token: string) => {
  const body = {
    token,
  };

  const response = await axiosInstance.post(
    `${REACT_APP_API_SERVER_URL}/api/reset-provider-choice`,
    body,
  );

  return response;
};

export const tfaVerifyCode = async (userCredentials: UserCredentials) => {
  const body = {
    verificationCode: userCredentials.authCode,
  };

  const response = await axiosInstance.post(
    `${REACT_APP_API_SERVER_URL}/api/tfa`,
    body,
  );

  return response.status === 200;
};

export const getUser = async () => {
  const response = await axiosInstance.get<User>(
    `${REACT_APP_API_SERVER_URL}/api/user-profile`,
  );

  const { data } = response;
  const user = { ...data };
  return user;
};

export const logout = async () => {
  const response = await axiosInstance.post(
    `${REACT_APP_API_SERVER_URL}/api/logout`,
  );

  return response.status === 200;
};

export const forgottenPassword = async (username: string) => {
  const response = await axiosInstance.post(
    `${REACT_APP_API_SERVER_URL}/api/forgotten-password?username=${username}`,
  );

  return response.status === 200;
};
